import { Box } from '@mui/material';
import React, { useState } from 'react'
import AirPortDetails from '../Booking/AirPortDetails';
const ServiceForm = () => {
  return (
    <Box
      sx={{
        margin: '30px',
        display: 'flex',
        justifyContent: { xs: 'center', sm: 'start' }
      }}
    >
      <AirPortDetails />
    </Box>
  )
}
export default ServiceForm;